import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const userMenuTrigger = style({
  padding: primitiveTokens.sizing["1x"],
  paddingRight: primitiveTokens.sizing["6x"],
  display: "flex"
});

export const avatarAndName = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"],
  overflow: "hidden"
});

export const avatarStyle = style({
  flexShrink: 0
});

export const nameStyle = style({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
});

// Stacks the user name over the subtitle on the trigger.
export const nameBlock = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  overflow: "hidden"
});

export const subtitleStyle = style({
  fontSize: primitiveTokens.type.xs,
  color: semanticThemeTokens.userMenu.iconColor,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
});

export const subMenuItemLabel = style({
  flex: 1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
});

export const activeCheck = style({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto"
});

export const itemIcon = style({
  display: "flex",
  alignItems: "center",
  color: semanticThemeTokens.userMenu.iconColor
});
